import { render, staticRenderFns } from "./ItsStockRawInBoundDepartDetail.vue?vue&type=template&id=d89a9ae0&scoped=true&"
import script from "./ItsStockRawInBoundDepartDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockRawInBoundDepartDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockRawInBoundDepartDetail.vue?vue&type=style&index=0&id=d89a9ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89a9ae0",
  null
  
)

export default component.exports